<div class="app-dialog-header" mat-dialog-title>
    <h2 class="app-dialog-title mb-0">{{ dialogTitle }}</h2>
    <p class="app-dialog-subtitle mb-3">{{ data.doorType?.is_system ? data.doorType?.title : 'Set the door type details and its maintenance reminder schedule.' }}</p>
</div>

<mat-dialog-content class="mat-typography">
    @if (errorMessage) { <app-alert tone="error">{{ errorMessage }}</app-alert> }

    <form [formGroup]="form" class="door-type-form">
        @if (!data.doorType?.is_system) {
            <section class="form-section">
                <div class="section-heading">
                    <span>Door type details</span>
                    <small>The name shown when completing a Fire Doors survey.</small>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Door type name</mat-label>
                    <input matInput formControlName="title" maxlength="125" autocomplete="off" />
                    <mat-hint align="end">{{ form.controls.title.value?.length ?? 0 }}/125</mat-hint>
                    @if (form.controls.title.hasError('required')) { <mat-error>Enter a door type name.</mat-error> }
                </mat-form-field>
            </section>
        }

        <section class="form-section schedule-section" [class.schedule-section--enabled]="scheduleEnabled">
            <div class="schedule-toggle">
                <div class="schedule-toggle__copy">
                    <div class="schedule-toggle__title"><mat-icon aria-hidden="true">notifications_active</mat-icon><span>Maintenance reminders</span></div>
                    <p>Automatically calculate when doors of this type are due for inspection.</p>
                </div>
                <mat-slide-toggle formControlName="maintenance_enabled" aria-label="Enable maintenance reminders"></mat-slide-toggle>
            </div>

            @if (scheduleEnabled) {
                <div class="schedule-fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Inspection frequency</mat-label>
                        <input matInput type="number" formControlName="inspection_frequency_months" min="1" step="1" />
                        <span matTextSuffix>months</span>
                        <mat-hint>Time between inspections</mat-hint>
                        @if (form.controls.inspection_frequency_months.hasError('required')) { <mat-error>Enter an inspection frequency.</mat-error> }
                        @if (form.controls.inspection_frequency_months.hasError('min') || form.controls.inspection_frequency_months.hasError('integer')) { <mat-error>Use a whole number of at least 1.</mat-error> }
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Notify before</mat-label>
                        <input matInput type="number" formControlName="notify_days_before" min="0" step="1" />
                        <span matTextSuffix>days</span>
                        <mat-hint>Optional; use 0 for the due date</mat-hint>
                        @if (form.controls.notify_days_before.hasError('min') || form.controls.notify_days_before.hasError('integer')) { <mat-error>Use zero or a positive whole number.</mat-error> }
                    </mat-form-field>
                </div>
            } @else {
                <div class="schedule-disabled-copy"><mat-icon aria-hidden="true">info</mat-icon><span>No inspection due dates or reminder notifications will be generated for this door type.</span></div>
            }
        </section>

        @if (data.doorType?.is_system) {
            <div class="system-note"><mat-icon aria-hidden="true">lock</mat-icon><span><strong>System door type</strong>The name is managed by Vulcan, but its maintenance settings can be changed for your organisation.</span></div>
        }
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close [disabled]="saving">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">
        {{ saving ? 'Saving…' : (data.doorType ? 'Save changes' : 'Create door type') }}
    </button>
</mat-dialog-actions>
